import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M17.6 6H6.4c-.77 0-1.393.731-1.393 1.625L5 17.375C5 18.269 5.63 19 6.4 19h11.2c.77 0 1.4-.731 1.4-1.625v-9.75C19 6.731 18.37 6 17.6 6ZM14 17.375H6.4v-3.18H14v3.18Zm0-4.17H6.4v-3.143H14v3.143Zm3.6 4.17H15v-7.313h2.6v7.313Z" }));
export default createSvgIcon(iconPath, "Page");
//# sourceMappingURL=PageIcon.js.map